import {
  getPeanutButterPackage,
  updatePeanutButterPackage,
} from './PeanutButter/PeanutButter'
import { getDryBeansPackage, updateDryBeansPackage } from './DryBeans/DryBeans'
import {
  getCannedBeansPackage,
  updateCannedBeansPackage,
} from './CannedBeans/CannedBeans'

export const getLegumesPackage = subCategory => {
  switch (subCategory) {
    case '001':
      return getPeanutButterPackage
    case '002':
      return getDryBeansPackage
    case '003':
      return getCannedBeansPackage
    default:
      break
  }
}

export const updateLegumesPackage = newProduct => {
  switch (newProduct.fkSubCategory) {
    case '001':
      return updatePeanutButterPackage(newProduct)
    case '002':
      return updateDryBeansPackage(newProduct)
    case '003':
      return updateCannedBeansPackage(newProduct)
    default:
      break
  }
}
